module.exports = __webpack_public_path__ + "assets/img/activity-ed.10a0df4d.png";